import { N900 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React from 'react';

export type PriceDisplayProps = {
  readonly formattedPrice: string;
  readonly fontSize: string;
  readonly planName: string;
};

export const PriceDisplay = ({
  formattedPrice,
  fontSize,
  planName
}: PriceDisplayProps) => (
  <FormattedPriceDisplay>
    <div
      data-cy={`plan-card-price-${planName.toLowerCase()}`}
      style={{ fontSize }}
    >
      {formattedPrice}
    </div>
  </FormattedPriceDisplay>
);

const FormattedPriceDisplay = styled.div`
  align-self: center;
  color: ${N900};
  font-family: Charlie Display;
  font-size: 54px;
  font-weight: 500;
  line-height: 54px;
  margin: 24px 0 8px;
`;
